import { render, staticRenderFns } from "./addOrEditClass.vue?vue&type=template&id=7d9cd970&scoped=true&"
import script from "./addOrEditClass.vue?vue&type=script&lang=js&"
export * from "./addOrEditClass.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditClass.vue?vue&type=style&index=0&id=7d9cd970&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9cd970",
  null
  
)

export default component.exports